import * as types from '../types'

const {SET_TITLE} = types.global

const companyName = '极简清单'

const refreshTitle = title => {
  $('<iframe width="0" height="0" src=\'https://app.huoban.com/favicon.ico\' style="display: none"></iframe>')
    .one('load', function(e) {
      setTimeout(n => this.parentNode.removeChild(this), 0)
    })
    .appendTo(document.body)
}
// 子模块的数据，作为全局store下state的sub-tree
const state = {
  docTitle: ''
}

// 对子模块数据的操作
const mutations = {
  [SET_TITLE](state, title, addName) {
    let arr = (title ? [].concat(title) : []).concat(addName ? companyName : [])
    let tt = arr.join('_') || companyName

    document.title = tt
    if (state.isInWechat && state.isIPhone) {
      refreshTitle(tt)
    }

    state.docTitle = tt
  }
}

export default {
  state,
  mutations
}



/** WEBPACK FOOTER **
 ** ./src/vuex/modules/global.js
 **/